import AssetsProvider from 'providers/AssetsProvider';
import EventsProvider from 'providers/EventsProvider';
import EventsTimeline from 'components/EventsTimeline';
import Header from 'components/Header';
import Panel from 'components/Panel';
import React from 'react';
import useTranslate from 'hooks/useTranslate';
import VestingBalance from 'components/VestingBalance';
import VestingChart from 'components/VestingChart';
import VestingContext from 'contexts/VestingContext';
import VestingProvider from 'providers/VestingProvider';
import {
  Box,
  Center,
  Container,
  Heading,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
} from '@chakra-ui/react';

const HomePage: React.FC = () => {
  const translate = useTranslate();

  return (
    <AssetsProvider>
      <VestingProvider>
        <EventsProvider>
          <Header />

          <Container>
            <VestingContext.Consumer>
              {({ data, hasVestingEnded }) =>
                data ? (
                  <VStack w="full" align="stretch" pt="12" pb="16" spacing="3">
                    <Panel p="3">
                      <Heading
                        fontSize="2xl"
                        fontWeight="bold"
                        px="3"
                        pb="4"
                        pt="1.5"
                      >
                        {translate('home:vesting:title')}
                      </Heading>

                      <VestingBalance />
                    </Panel>

                    <Panel px="5" pb="6">
                      {hasVestingEnded ? (
                        <Box>
                          <Heading fontSize="xl" fontWeight="bold" mb="4">
                            {translate('home:tabs:timeline')}
                          </Heading>
                          <EventsTimeline />
                        </Box>
                      ) : (
                        <Tabs isFitted>
                          <TabList>
                            <Tab>{translate('home:tabs:chart')}</Tab>
                            <Tab>{translate('home:tabs:timeline')}</Tab>
                          </TabList>
                          <TabPanels>
                            <TabPanel>
                              <VestingChart />
                            </TabPanel>
                            <TabPanel>
                              <EventsTimeline />
                            </TabPanel>
                          </TabPanels>
                        </Tabs>
                      )}
                    </Panel>
                  </VStack>
                ) : (
                  <Center height="34rem">
                    <Spinner
                      size="xl"
                      color="primary.500"
                      thickness="4px"
                      my="20"
                      mx="auto"
                      display="block"
                    />
                  </Center>
                )
              }
            </VestingContext.Consumer>
          </Container>
        </EventsProvider>
      </VestingProvider>
    </AssetsProvider>
  );
};

export default HomePage;
